import { useI18n } from 'vue-i18n';
import { shallowRef } from 'vue';
import BaseMoney from 'presentation/components/BaseMoney/BaseMoney.vue';
import BaseDate from 'presentation/components/BaseDate/BaseDate.vue';
import LineItemInfo from 'presentation/CartDetail/CartLikeContentDetail/LineItemInfo/LineItemInfo.vue';
import CartLikeContentDetail from 'presentation/CartDetail/CartLikeContentDetail/CartLikeContentDetail.vue';
import BaseAddress from 'presentation/components/BaseAddress/BaseAddress.vue';
import useCustomerTools, { isSeller } from 'hooks/useCustomerTools';
import useQuoteTools from 'hooks/useQuoteTools';
import Modal from 'presentation/components/Modal/Modal.vue';
import { apolloClient, } from '../../../../apollo';
import gql from 'graphql-tag';
import { useRouter, useRoute } from 'vue-router';
import useCart from 'hooks/useCart';
import Spinner from 'presentation/components/CustomSpinner/CustomSpinner.vue';
import Toast from 'presentation/components/Toast/Toast.vue';
import QuotationCart from 'presentation/User/QuotationCart/QuotationCart.vue';


export default {
    components: {
        CartLikeContentDetail,
        BaseDate,
        BaseMoney,
        BaseAddress,
        LineItemInfo,
        Modal, 
        Spinner,
        Toast,
        QuotationCart
    },
    setup(){
        const { t } = useI18n();
        const tools = useCustomerTools();
        const { loading, quote, getMyQuote, acceptQuoteRequest, sendStagedQuote, rejectQuoteRequest, quoteRefetch, addSellerComment } = tools.useMyQuote();
        const { addDirectDiscount, createFinalQuotation, setLineItemPrice } = useQuoteTools();
        const router = useRouter();
        const isSellerUser = isSeller();
        const { refetch } = useCart();
        const isShowSpinner = shallowRef(false);
        const toastMessage = shallowRef(null);
        const finalQuote = shallowRef(null);
        const isQuoteOrdered = shallowRef(false);
        const toastType = shallowRef(null);
        const route = useRoute();
        
        const confirmAcceptQuoteRequest = () => {
          isShowSpinner.value = true;
          acceptQuoteRequest()
          .then(acceptQuoteRequestResponse => {
            setTimeout(()=>{
              let tempAcceptResponse = acceptQuoteRequestResponse.data.value.stagedQuotes.results[0];
              if(acceptQuoteRequestResponse.data.value) {
                quote.value = {
                  ...tempAcceptResponse,
                  lineItems: tempAcceptResponse?.quotationCart?.lineItems
                  .map((item) => {return item;})
                  .filter(({ quantity }) => Boolean(quantity)),
                  ...tempAcceptResponse.quotationCart,
                  id: tempAcceptResponse.id,
                  quotationCartId: tempAcceptResponse.quotationCart.id,
                  comment: tempAcceptResponse.quoteRequest?.comment
                };
                getMyQuote()
                .then(resp => {
                  setTimeout(()=>{
                    if(resp.data) {
                      finalQuote.value = resp.data.value.quotes.results[0];
                      if(finalQuote.value && finalQuote.value.quoteState === 'Accepted') {
                        isQuoteOrdered.value = true;
                      } else {
                        isQuoteOrdered.value = false;
                      }
                    }
                  }, 2000)
                })
                router.replace({path: route.path, query: {state: 'Accepted'}})
                isShowSpinner.value = false;
              } else {
                isShowSpinner.value = false;
              }
            }, 3000)
          })
          .catch(err =>{
            console.log(err);
            isShowSpinner.value = false;
          });
        };

        const setToast = (message, type) => {
          if(message){
            toastMessage.value = message;
            toastType.value = type;
  
            setTimeout(()=>{
              toastMessage.value = null;
              toastType.value = null;
            }, 4000);
          }
        }

        const confirmSendStagedQuoteToUser = () => {
          isShowSpinner.value = true;
          sendStagedQuote(quote.value.version, quote.value.id)
          .then(sendStagedQuoteResp => {
            if(sendStagedQuoteResp.data.updateStagedQuote) {
              let tempsendStagedQuoteResponse = sendStagedQuoteResp.data.updateStagedQuote;

              quote.value = {
                ...tempsendStagedQuoteResponse,
                lineItems: tempsendStagedQuoteResponse?.quotationCart?.lineItems
                .map((item) => {return item;})
                .filter(({ quantity }) => Boolean(quantity)),
                ...tempsendStagedQuoteResponse.quotationCart,
                id: tempsendStagedQuoteResponse.id,
                quotationCartId: tempsendStagedQuoteResponse.quotationCart.id
              };

              isShowSpinner.value = false;
              setToast("Quotation sent to the buyer successfully!", 'success')
            }
            
          })
          .catch(err=>{
            console.log(err);
            isShowSpinner.value = false;
          })
        }

        const confirmRejectQuoteRequest = () => {
          isShowSpinner.value = true;
          rejectQuoteRequest()
          .then(rejectedResponse=>{
            console.log(rejectedResponse)
            isShowSpinner.value = false;
            setToast("Quote request was rejected!", 'success')
          })
          .catch(err=> console.log(err))
        }

        return {
            t,
            quote,
            loading,
            getMyQuote,
            router,
            isSellerUser,
            confirmAcceptQuoteRequest,
            refetch,
            isShowSpinner,
            confirmSendStagedQuoteToUser,
            setToast,
            toastMessage,
            toastType,
            confirmRejectQuoteRequest,
            quoteRefetch,
            addDirectDiscount,
            finalQuote,
            isQuoteOrdered,
            createFinalQuotation,
            addSellerComment,
            setLineItemPrice
        }
    },
    data: () => ({
      isModalVisible: false,
      selectedQuote: null,
      modalType: null,
      modalMessage: null,
      modalTitle: null,
      isEditQuotationCart: false
    }),
    props: ['query'],
    mounted() {
      const route = useRoute();
      if(route.query.state === 'Accepted') {
        this.getMyQuote()
        .then(resp => {
          setTimeout(()=>{
            if(resp.data) {
              this.finalQuote = resp.data.value.quotes.results[0];
              if(this.finalQuote && this.finalQuote.quoteState === 'Accepted') {
                this.isQuoteOrdered = true;
              } else {
                this.isQuoteOrdered = false;
              }
            }
          }, 2000)
        })
      } else {
        console.log("Not accepted")
      }
    },
    computed: {
        subtotal(){
            if (this.quote?.totalPrice) {
              const { currencyCode, fractionDigits } = this.quote.totalPrice;
              return {
                centAmount: this.quote.lineItems ? this.quote.lineItems.reduce(
                  (acc, li) => acc + li.totalPrice.centAmount,
                  0
                ) : undefined,
                currencyCode,
                fractionDigits,
              };
            }
            return null;
        },
        paymentInfo(){
            return this.quote?.paymentInfo?.payments?.[0]
              ?.paymentStatus?.interfaceCode
              ? this.t(
                  this.quote?.paymentInfo?.payments?.[0]
                    ?.paymentStatus?.interfaceCode
                )
              : '';
          }
    },
    methods: {
      showModal(type, data){
          this.isModalVisible = true;
          this.selectedQuote = data.quote;
          this.modalType = type;
          if(type === 'acceptAndOrder') {
            this.modalMessage = 'Current cart will be updated with the quotation products.'
            this.modalTitle = 'Accept Quote and Order'
          }
      },
      hideModal(){
          this.isModalVisible = false;
          this.selectedQuote = null;
          this.modalType = null;
          this.modalMessage = null;
          this.modalTitle = null;
          this.isEditQuotationCart = false;
      },
      formatQueryObject(obj) {
        let {["__typename"]: _, ...rest} = obj;
        console.log(_)
        return rest;
      },
      proceedToOrder() {
        this.hideModal();
        this.isShowSpinner = true;
        if(this.finalQuote) {
          const { billingAddress, lineItems, shippingAddress, id, version, directDiscounts } = this.finalQuote;
          
          apolloClient.mutate({
            mutation: gql`
              mutation CreateMyCart($draft: MyCartDraft!){
                createMyCart(draft: $draft) {
                    customerId
                    createdCartVersion: version
                    createdCartId: id
                    lineItems {
                      id
                      productId
                    }
                }
              }
            `,
            variables: {
              "draft":{
                  "lineItems": lineItems.map(item =>({"productId": item.productId, "quantity": item.quantity})),
                  "currency": this.currency ? this.currency : "EUR",
                  "billingAddress": billingAddress ? this.formatQueryObject(billingAddress) : null,
                  "shippingAddress": shippingAddress ? this.formatQueryObject(shippingAddress) : null
              }
            }
          }).then(createCartResponse => {
            const { createdCartId, createdCartVersion } = createCartResponse.data.createMyCart;
            const createdCartLineItems = createCartResponse.data.createMyCart.lineItems;
            const addPriceToLineItemActions = lineItems.map((item, index) => 
              ({"setLineItemPrice" : {
                "lineItemId": createdCartLineItems[index]?.id,
                "externalPrice": {
                    "centPrecision": {
                        "centAmount": item.price.value.centAmount,
                        "currencyCode": item.price.value.currencyCode
                    }
                }
            }}));

            this.setLineItemPrice(createdCartId, createdCartVersion, addPriceToLineItemActions)
            .then((setLineItemPriceResponse)=>{
              const cartVersionAfterPriceUpdate = setLineItemPriceResponse.data.updateCart.version;
              let updateCartSetDirectDiscountsResp;
              if(directDiscounts && directDiscounts.length) {
                const discountsFormat = [{
                  value: {
                    relative: {
                      permyriad: parseInt(directDiscounts[0].value.permyriad),
                    },
                  },
                  target: {
                    [directDiscounts[0].target.type] : {
                      predicate: "1=1",
                    },
                  },
                }];
                updateCartSetDirectDiscountsResp = this.addDirectDiscount(createdCartId, cartVersionAfterPriceUpdate, discountsFormat)
              } else {
                updateCartSetDirectDiscountsResp = Promise.resolve(true);
              }
              updateCartSetDirectDiscountsResp.then(()=>{
                this.refetch().then(()=> {
                  this.isShowSpinner = false;
                  this.router.push({
                    name: 'checkout',
                    query: { stage: 'orderQuote', quoteId:  id, quoteVersion: version, requestId: this.quote.quoteRequest.id, requestVersion: this.quote.quoteRequest.version},
                  });
                });
              })
              .catch(err=>console.error(err));
            })
            .catch(err=> console.error(err));
          })
          .catch(err=>console.error(err));
        }
      },
      modifyQuotationCart() {
        this.isEditQuotationCart = true;
      },
      sendFinalQuote() {
        const quotationCartData = this.$refs.quotationCartRef;
        const discountsFormat = [{
            value: {
              relative: {
                permyriad: parseInt(quotationCartData.discountValue) * 100,
              },
            },
            target: {
              lineItems: {
                predicate: "1=1",
              },
            },
          }];

        this.addDirectDiscount(this.quote.quotationCartId, this.quote.quotationCart.version, discountsFormat)
        .then(()=>{
          this.addSellerComment(this.quote.version, this.quote.id, quotationCartData.quoteComment)
          .then(stagedQuoteSellerCommentResp=> {
            this.createFinalQuotation(this.quote.id, stagedQuoteSellerCommentResp.data.updateStagedQuote.version)
            .then(createQuoteResponse => {
              console.log(createQuoteResponse)
              this.confirmSendStagedQuoteToUser();
              this.isEditQuotationCart = false;
            })
            .catch(err=> console.error(err));
          })
          .catch(err=> console.error(err));
        })
        .catch(err=> console.error(err));
      },
      sendFinalQuoteDirect(){
        this.createFinalQuotation(this.quote.id, this.quote.version)
        .then(() => {
          this.confirmSendStagedQuoteToUser();
          this.isEditQuotationCart = false;
        })
        .catch(err=> console.error(err));
      }
    }
}

